import React, { useEffect, useState } from "react";
import { CartProvider } from "./context/CartContext";
import MenuPager from "./components/MenuPager";
import { enviardatosservidor } from "./components/util/utilities";
import { BASE_URL } from "./components/util/formatUtils";
import HomePage from "./components/HomePage";
import "./styles.css";
import "./App.css";

function App() {
  const [menu, setMenu] = useState([]);

  const platos = menu.filter((item) => item.category === "Arepas Rellenas");
  const bebidas = menu.filter((item) => item.category === "Bebidas");
  const [selectedCategory, setSelectedCategory] = useState(null);

  const consultarinit = async () => {
    const collection = {}; // o los datos reales que necesites enviar

    try {
      const data = await enviardatosservidor(
        collection,
        `${BASE_URL}Carta/consultaproductos.php`,
        "POST",
      );

      console.log("✅ RESPUESTA DEL SERVIDOR:", JSON.stringify(data));

      if (data?.status && Array.isArray(data.data)) {
        setMenu(data.data); // 👈 AQUÍ ESTÁ LA CLAVE

        console.log("🍽️ Menu cargado desde servidor");
      } else {
        console.warn("⚠ Respuesta sin status true", data);
      }
    } catch (error) {
      console.error("❌ Error al consultar servidor:", error);
    }
  };

  useEffect(() => {
    // Mientras desarrollas usa el JSON local
    consultarinit();
  }, []);

  return (
    <CartProvider>
      <div className="App">
        <header className="app-header">
          <img
            src={require("./Logos/LevelPub.png")}
            alt="Level Pub"
            className="app-logo"
          />
        </header>

        {!selectedCategory ? (
          <HomePage
            menu={menu}
            onSelectCategory={(cat) => setSelectedCategory(cat)}
          />
        ) : (
          <MenuPager
            items={menu.filter((item) => item.category === selectedCategory)}
            onBack={() => setSelectedCategory(null)}
          />
        )}
      </div>
    </CartProvider>
  );
}

export default App;
